import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../api";
import { btnPrimary, btnSage, inputCls, panel } from "./ui";

const EMPTY = { name: "", level: "", schedule: "", teacherName: "", scaleMin: 1, scaleMax: 10 };

function CourseRow({ course, onSaved }) {
  const [edit, setEdit] = useState(null);
  const [err, setErr] = useState("");
  const save = async () => {
    try {
      await api.patch(`/courses/${course.id}`, {
        ...edit,
        scaleMin: Number(edit.scaleMin),
        scaleMax: Number(edit.scaleMax),
      });
      setEdit(null);
      setErr("");
      onSaved();
    } catch (ex) {
      setErr(formatApiError(ex));
    }
  };
  if (!edit) {
    return (
      <tr className="border-t border-[#132C44]/5" data-testid={`eid-course-row-${course.id}`}>
        <td className="p-3 font-semibold">{course.name}</td>
        <td className="p-3">{course.level}</td>
        <td className="p-3">{course.schedule || "—"}</td>
        <td className="p-3">{course.scaleMin}–{course.scaleMax}</td>
        <td className="p-3 text-right">
          <button onClick={() => setEdit({ name: course.name, level: course.level, schedule: course.schedule || "", teacherName: course.teacherName || "", scaleMin: course.scaleMin, scaleMax: course.scaleMax })} className="text-[12px] font-semibold hover:underline" data-testid={`eid-course-edit-${course.id}`}>
            Editar
          </button>
        </td>
      </tr>
    );
  }
  const f = (k) => (e) => setEdit({ ...edit, [k]: e.target.value });
  return (
    <tr className="border-t border-[#132C44]/5 bg-[#F6EFDF]/50">
      <td className="p-2"><input className={inputCls} value={edit.name} onChange={f("name")} data-testid="eid-course-edit-name" /></td>
      <td className="p-2"><input className={inputCls} value={edit.level} onChange={f("level")} /></td>
      <td className="p-2"><input className={inputCls} value={edit.schedule} onChange={f("schedule")} /></td>
      <td className="p-2">
        <div className="flex gap-1 items-center">
          <input type="number" className={inputCls} value={edit.scaleMin} onChange={f("scaleMin")} data-testid="eid-course-edit-min" />
          <span>–</span>
          <input type="number" className={inputCls} value={edit.scaleMax} onChange={f("scaleMax")} data-testid="eid-course-edit-max" />
        </div>
        {err && <div className="text-[11px] text-[#9B2C3B] mt-1">{err}</div>}
      </td>
      <td className="p-2 text-right whitespace-nowrap">
        <button onClick={save} className={btnSage} data-testid="eid-course-edit-save">Guardar</button>
        <button onClick={() => setEdit(null)} className="ml-2 text-[12px] hover:underline">Cancelar</button>
      </td>
    </tr>
  );
}

export default function CoursesPanel() {
  const [courses, setCourses] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [err, setErr] = useState("");
  const load = () => api.get("/courses").then(({ data }) => setCourses(data));
  useEffect(() => {
    load();
  }, []);

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/courses", { ...form, scaleMin: Number(form.scaleMin), scaleMax: Number(form.scaleMax) });
      setForm(EMPTY);
      setErr("");
      load();
    } catch (ex) {
      setErr(formatApiError(ex));
    }
  };
  const f = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="space-y-6" data-testid="eid-admin-courses">
      <form onSubmit={create} className={`${panel} grid sm:grid-cols-2 lg:grid-cols-6 gap-3 items-end`}>
        <label className="lg:col-span-2 text-[11px] font-semibold">Nombre<input required className={inputCls} value={form.name} onChange={f("name")} placeholder="Teens B1 · Jueves" data-testid="eid-course-new-name" /></label>
        <label className="text-[11px] font-semibold">Nivel<input required className={inputCls} value={form.level} onChange={f("level")} placeholder="B1" data-testid="eid-course-new-level" /></label>
        <label className="text-[11px] font-semibold">Horario<input className={inputCls} value={form.schedule} onChange={f("schedule")} placeholder="Jue 18:00" /></label>
        <label className="text-[11px] font-semibold">Escala de notas
          <div className="flex gap-1 items-center">
            <input type="number" className={inputCls} value={form.scaleMin} onChange={f("scaleMin")} data-testid="eid-course-new-min" />
            <span>–</span>
            <input type="number" className={inputCls} value={form.scaleMax} onChange={f("scaleMax")} data-testid="eid-course-new-max" />
          </div>
        </label>
        <button type="submit" className={btnPrimary} data-testid="eid-course-new-submit">Crear curso</button>
      </form>
      {err && <div className="text-[13px] text-[#9B2C3B]" data-testid="eid-course-error">{err}</div>}
      <div className="overflow-x-auto rounded-2xl bg-white border border-[#132C44]/10">
        <table className="w-full text-[13px]">
          <thead className="bg-[#132C44]/5 text-left text-[10px] uppercase tracking-widest">
            <tr><th className="p-3">Curso</th><th className="p-3">Nivel</th><th className="p-3">Horario</th><th className="p-3">Escala</th><th className="p-3" /></tr>
          </thead>
          <tbody>
            {courses.map((c) => <CourseRow key={c.id} course={c} onSaved={load} />)}
          </tbody>
        </table>
      </div>
    </div>
  );
}
